<table>
    <thead>
        <tr>
            <th class="subtable string">{{'etiquetado.table.tabs.confeccion.confeccion' | translate}}</th>
            <th class="subtable string">{{'global.unidades' | translate}}</th>
            <th class="subtable number">{{'global.confeccionKg' | translate}}</th>
        </tr>
    </thead>
    <tbody *ngFor="let confeccion of confecciones">
        <tr>
            <td class="string">{{confeccion.desConfeccion}}</td>
            <td class="string">{{confeccion.sumaNumEtiquetasImpresasEfectivas | number : '1.0-0': defaultLanguage}}</td>
            <td class="number">{{confeccion.sumaKgImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
        </tr>
    </tbody>
</table>